import { Input } from '@dnb/eufemia';
import { debounce } from '@portals/shared-frontend/utils';
import { useMemo } from 'react';

import type { NavigationItem } from './index';

import Fuse from 'fuse.js';

export type FlattenedItem = {
  displayName: string;
  slug: string;
};

type SearchProps = {
  items: NavigationItem[];
  onSearchResult: (matchingItems: FlattenedItem[] | undefined) => void;
};

const flattenItems = (navItems: NavigationItem[]): FlattenedItem[] => {
  return navItems.flatMap((item) => [
    { displayName: item.displayName, slug: item.slug },
    ...flattenItems(item.children),
  ]);
};

export const Search = ({ items, onSearchResult }: SearchProps) => {
  const fuse = useMemo(() => {
    if (items && items.length > 0) {
      const flattenedItems: FlattenedItem[] = flattenItems(items);
      return new Fuse(flattenedItems, {
        keys: ['displayName', 'slug'],
        threshold: 0.3,
        ignoreLocation: true,
        shouldSort: false,
        useExtendedSearch: true,
      });
    }
    return null;
  }, [items]);

  const handleChange = debounce(({ value }) => {
    if (value.length >= 2 && fuse) {
      const searchResults = fuse.search(value);
      const matchingItems = searchResults.map((result) => result.item);
      onSearchResult(matchingItems);
    } else {
      onSearchResult(undefined);
    }
  }, 300);

  return (
    <div className="flex justify-center mb-4 mt-8">
      <Input clear on_change={handleChange} placeholder="Search" type="search" />
    </div>
  );
};
